import taskMgmtSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const taskMgmtActions = { ...actions, ...thunkActions };
export * as TaskMgmtTypes from './types';
export default taskMgmtSlice;
